<template>
  <template v-if="$route.params.uPage === 'DadosPessoais'">
    <v-card>
      <v-card-text>
        <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
        <v-form v-model="isFormDPValid" @submit.prevent="onSubmit">
          CPF
          <v-text-field v-model="cpf.value.value" v-mask="'###.###.###-##'" disabled />
          E-mail
          <v-text-field v-model="email.value.value" disabled />
          Nome
          <v-text-field v-model="nome.value.value" color="primary" :counter="100" :error-messages="nome.errorMessage.value" />
          Gênero
          <v-select v-model="sexo.value.value" color="primary" :error-messages="sexo.errorMessage.value" :items="items" />
          Telefone
          <v-text-field v-model="fone.value.value" v-mask="['(##) ####-####', '(##) #####-####']" color="primary" :error-messages="fone.errorMessage.value" />
          <v-btn class="bg-primary mt-4" type="submit" :disabled="!isFormDPValid" :loading="loadingUserData">Alterar</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </template>
  <template v-else-if="$route.params.uPage === 'Seguranca'">
    <v-card>
      <v-card-text>
        <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
        <v-form ref="formChangePwd" @submit.prevent="onSubmitChangePwd">
          <v-text-field v-model="old_senha" color="primary" label="Senha antiga" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="requiredField" :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1" />
          <v-text-field v-model="senha" color="primary" label="Nova senha" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="passwordRules" :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2" />
          <v-text-field v-model="check_senha" color="primary" label="Confirmar Senha" :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'" :rules="requiredField.concat(passwordConfirmationRule)" :type="show3 ? 'text' : 'password'"
            @click:append="show3 = !show3" />
          <v-btn class="bg-primary mt-4" type="submit">Alterar</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </template>
  <v-snackbar v-model="snackbar" :color="sbColor">
    {{ sbMessage }}
    <template v-slot:actions>
      <v-btn @click="snackbar = false">Fechar</v-btn>
    </template>
  </v-snackbar>
</template>
 
<script src="@/assets/js/usuario.js" />
